// This is the entry point for the React application.
// It renders the main App component and sets up performance monitoring.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firebase';
import { maybeResetAppState } from './utils/resetAppState';

// Runs before mounting so a ?reset=1 link can repair cached state even when the
// app itself would fail to start.
maybeResetAppState().then((didReset) => {
  // A reset navigates away; rendering here would only be thrown out.
  if (didReset) return;

  // Create a root for the React application
  const root = ReactDOM.createRoot(document.getElementById('root'));

  // Render the App component within StrictMode
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});